import { memo, useEffect } from "react";
import { Button, Checkbox, Popconfirm, Space, Table, TableProps, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { mdlMarket } from "../../../models/domain/Market";
import { mdlTablePagination } from "../../../models/ui-models/TablePagination";
import { QuestionCircleOutlined } from '@ant-design/icons';
import $ from 'jquery';
import { mdlHotelRoom } from "../../../models/domain/HotelRoom";
import { AbstractCheckboxProps, CheckboxChangeEvent } from "antd/es/checkbox/Checkbox";
import { HotelSelect } from "../../common/HotelSelect";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type RoomTableProps = {
    fnSelectAll?: any;
    onTableItemSelect?: any;
    tableItems?: mdlHotelRoom[];
    onDelete?: Function;
    onEdit?: Function;
    pagination: mdlTablePagination;
    onTableParamsChange?: Function;
    selectedRoomList?: string[];
    selectedHotel?:string;
}

export const RoomTable = memo(function RoomTable(props: RoomTableProps) {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);


    const checkList = (id:string) => {
        return (props.selectedRoomList?.find(x => x==id) != undefined) as boolean;
    }
    const columns: TableProps<mdlHotelRoom>['columns'] = [
        {
            title: <>
                <Checkbox onClick={props.fnSelectAll} checked={props.selectedRoomList?.length == props.tableItems?.length}></Checkbox>
            </>,
            key: 'check',
            width:30,
            render: (_, record) => (
                <Space size="middle">
                    <Checkbox onChange={props.onTableItemSelect} checked={checkList(record.id)} value={record.id}></Checkbox>
                </Space>
            ),
        },
        {
            title: t("definitions.hotels.name"),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: t("common.actions"),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Popconfirm
                        title={t("common.deleteWarning")}
                        description={t("common.deleteDescription")}
                        okText={t("common.okConfirm")}
                        cancelText={t("common.cancelConfirm")}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => props.onDelete ? props.onDelete(record.id,record.roomId) : undefined}
                    >
                        <Button type="primary" danger>
                            {t("common.delete")}
                        </Button>
                    </Popconfirm>

                </Space>
            ),
        },
    ];

    const handleTableChange: TableProps<mdlHotelRoom>['onChange'] = (pagination, filters, sorter) => {
        props.onTableParamsChange && props.onTableParamsChange(pagination, filters);
    }

    return (
        <>
        <div className="row">
            {
                props.tableItems
                &&
                <div className="col-sm-12">
                    <Table<mdlHotelRoom>
                        onChange={handleTableChange}
                        size="middle"
                        columns={columns}
                        pagination={props.pagination}
                        scroll={{ x: 'max-content' }}
                        dataSource={props.tableItems.map((data: mdlHotelRoom, index: number) => ({ ...data, key: index }))}
                    />
                </div>
            }
            
            {
                !props.tableItems
                &&
                <div className="col-sm-12">
                    <div className="alert alert-warning alert-icon">
                        <FontAwesomeIcon icon={ faWarning } />
                        <span className="ps-4">{t('definitions.hotels.mustChooseHotel')}</span>
                    </div>
                </div>
            }
        </div>
        </>
    )
})